import { GuidelinesRepo } from '@/modules/guidelines/domain/GuidelinesRepo'
import { GuidelinesListScreenData } from '../domain/GuidelinesScreenData'

export class GuidelinesListComponent {

    guidelines_repo: GuidelinesRepo
    screen_data: GuidelinesListScreenData
    function_name_translator: any

    constructor(guidelines_repo, screen_data) {
        this.guidelines_repo = guidelines_repo
        this.screen_data = screen_data
        this.function_name_translator =  {}
    }

    refreshList() {
        this.screen_data.loadingItems = true
        this.guidelines_repo.get_guidelines_list(this.screen_data.limit, this.screen_data.offset).then((res) => {
            this.screen_data.guidelines = res['results']
            this.screen_data.totalItems = res['count']
            this.screen_data.loadingItems = false
            console.log(res['count'])
        })
    }

    async build_function_name_translator() {
            let res = await this.guidelines_repo.get_options()
            let translator = {}
            for (let f of res.conditions) {
                translator[f.func_name] = f.name
            }
            for (let f of res.consequences) {
                translator[f.func_name] = f.name
            }

            this.function_name_translator = translator
    }
}